import { TextField } from '@material-ui/core';
import React from 'react';
import InputMask from 'react-input-mask';

const PhoneNumberTextField = (props) =>{
    return (
        <InputMask
        mask="(999) 999-9999"
        maskChar="_"
        value={props.value}
        onChange={props.onChange}
        {...props}
        >
            {
                (inputProps) => (
                    <TextField 
                        {...inputProps}
                        label={props.label}
                        name={props.name}
                        variant={props.variant}
                        fullWidth={props.fullWidth}
                        required={props.required}
                        error={props.error}
                        helperText={props.helperText}
                    />
                )
            }
        </InputMask>
    )
}

export default PhoneNumberTextField;


// WEBPACK FOOTER //
// ./src/components/Common/PhoneNumberTextField/PhoneNumberTextField.js